import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import styles from './GuestNav.module.css'

// Guest navigation — shown only while the visitor is signed out.
// Renders nothing for authenticated users (the Navbar shows the account menu instead).
const GuestNav = ({ variant = 'desktop', onNavigate }) => {
  const { user } = useAuth()
  if (user) return null

  if (variant === 'mobile') {
    return (
      <div className={styles.mobileActions}>
        <Link to="/login" className={`btn btn-outline ${styles.btn}`} onClick={onNavigate}>
          Login
        </Link>
        <Link to="/signup" className={`btn btn-primary ${styles.btn}`} onClick={onNavigate}>
          Get Started
        </Link>
      </div>
    )
  }

  return (
    <>
      <Link to="/login" className={`btn btn-outline ${styles.btn}`}>
        Login
      </Link>
      <Link to="/signup" className={`btn btn-primary ${styles.btn}`}>
        Get Started
      </Link>
    </>
  )
}

export default GuestNav
